import React from 'react'
import styled from 'styled-components'
import Modal from '@mui/material/Modal';
import { useParams } from 'react-router-dom'
import AllocationAllocateModal from './AllocationAllocateModal';
import AddBoxIcon from '@mui/icons-material/AddBox';
import AllocationCreateShiftForm from './AllocationCreateShiftForm';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone.js';
import utc from 'dayjs/plugin/utc.js';
dayjs.extend(utc);
dayjs.extend(timezone);

const ShiftsContainer = styled.div`
  width: 90vw;
  min-height: 100vh;
  padding-left: 2vw;
  color: #555555;
`

const TitleBanner = styled.div`
  display: flex;
  justify-content: center;
  color: black;
`

const TitleBox = styled.div`
  font-size: 2rem;
  font-family: Montserrat;
  font-weight: bold;
  width: 90vw;

  display: flex;
  justify-content: space-between;
`

const ShiftBoxContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(100px, 1fr));
  grid-template-rows: repeat(3, minmax(100px, 1fr));

  gap: 10px;
`

const ShiftBox = styled.div`
  border: 1px solid #E3E4E6;
  border-radius: 5px;

  padding: 20px;

  height: 200px;

  display:flex;
  justify-content: space-between;
  flex-direction: column;
`

const ShiftBoxInfo = styled.div`
  font-size: 18px;

  display: flex;
  justify-content: space-between;
`

const ShiftRatio = styled.div`
  font-size: 20px;
  color: tomato;
  font-weight: bold;

  &.COMPLETE {
    color: #6347ff;
  }
`

const ShiftBoxButtonsContainer = styled.div`
  display: flex;
  gap: 10px;
  width: 100%;

  align-items: center;
`

const ShiftBoxButton = styled.div`

  color: #555555;
  font-weight: bold;

  border: 2px solid #777777;
  border-radius: 5px;

  width: 10vw;

  padding: 10px;
  text-align: center;
  cursor: pointer;

  &:hover {
    background: tomato;
    border: 2px solid tomato;
    color: white;
  }
`

const AddShiftButton = styled.div`
  cursor: pointer;
`

export default function AlllocationShifts() {

  const { JobId } = useParams()

  // -- Allocations Modal
  const [openAlloc, setOpenAlloc] = React.useState(false);
  const [chosenShift, setChosenShift] = React.useState([]);
  const handleOpenAlloc = (shift) => {
    setOpenAlloc(true)
    setChosenShift(shift)
  };
  const handleCloseAlloc = () => setOpenAlloc(false);

  // -- CreateShift Modal
  const [openCreateNew, setOpenCreateNew] = React.useState(false);
  const handleOpenCreateNew = () => {
    setOpenCreateNew(true)
  };
  const handleCloseCreateNew = () => setOpenCreateNew(false);

  // -- Workers Modal
  const getShifts = async () => {
    try {
      const res = await fetch(`/api/allocations/jobs/${JobId}/shifts`)
      const data = await res.json();
      return data
    } catch (error) {
      console.error("Error:", error)
    }
  }

  const getShiftWorkers = async () => {
    try {
      const res = await fetch(`/api/allocations/jobs/${JobId}/shifts/workers`)
      const data = await res.json();
      return data
    } catch (error) {
      console.error("Error:", error)
    }
  }

  const [shifts, setShifts] = React.useState([])
  const combineShiftAndWorkers = async () => {
    const workers = await getShiftWorkers();
    let shifts = await getShifts();

    const joinedData = shifts.map(shift => {
      // For each shift, find all matching workers
      const workersForShift = workers.filter(worker => worker.shift_id === shift.shift_id);

      // Extract the worker_ids from the matches
      const workerIds = workersForShift.map(worker => worker.worker_id);

      // Append the worker_id list to the shift object
      return { ...shift, worker_ids: workerIds };
    });

    // console.log(JSON.stringify(joinedData));
    setShifts(joinedData)
  }

  React.useEffect(() => {
    combineShiftAndWorkers();
  }, [])

  return (
    <ShiftsContainer>

      <Modal
        open={openAlloc}
        onClose={handleCloseAlloc}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <AllocationAllocateModal data={chosenShift} updatePage={combineShiftAndWorkers} closeModal={handleCloseAlloc}/>
      </Modal>

      <Modal
        open={openCreateNew}
        onClose={handleCloseCreateNew}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <AllocationCreateShiftForm jobId={JobId} updatePage={combineShiftAndWorkers} closeModal={handleCloseCreateNew}/>
      </Modal>

      <TitleBanner>
        <TitleBox>
          Shifts 
          <AddShiftButton onClick={()=>{handleOpenCreateNew()}}><AddBoxIcon sx={{color:"#4ddc00", fontSize:"3rem"}}/></AddShiftButton>
        </TitleBox>
      </TitleBanner>

      <ShiftBoxContainer>
        {shifts.map((shift, idx) => (
          <ShiftBox>
            <ShiftBoxInfo>
              <div>
                <div>{dayjs(shift.date).tz('Australia/Sydney').format('DD/MM/YYYY')}</div>
                <div>{dayjs(shift.startTime).tz('Australia/Sydney').format('h:mm a')} - {dayjs(shift.endTime).tz('Australia/Sydney').format('h:mm a')}</div>
                <div>{dayjs(shift.endTime).diff(dayjs(shift.startTime), 'hour', true)} hours</div>
              </div>
              <ShiftRatio>
                <div>{shift.worker_ids.length}/{shift.numWorkers}</div>
              </ShiftRatio>
            </ShiftBoxInfo>
            id: {shift.shift_id}
            <ShiftBoxButtonsContainer>
              <ShiftBoxButton onClick={()=>{handleOpenAlloc(shift)}}>ALLOCATE</ShiftBoxButton>
              <ShiftBoxButton>WORKERS</ShiftBoxButton>
            </ShiftBoxButtonsContainer>
          </ShiftBox>
        ))}

      </ShiftBoxContainer>
    </ShiftsContainer>
  )
}
